// @flow

export { onlyNumbers } from './only-numbers';
